// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot?61rdwy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?61rdwy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?61rdwy", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?61rdwy", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-plu-icon:before {
  content: "\\e95a";
}
.icon-magic-wand:before {
  content: "\\e959";
}
.icon-squence-architecturale-zoomed:before {
  content: "\\e958";
}
.icon-attique_correction:before {
  content: "\\e957";
}
.icon-parking-circulation:before {
  content: "\\e956";
}
.icon-parking-icon:before {
  content: "\\e95d";
}
.icon-arrow-up:before {
  content: "\\e955";
}
.icon-star:before {
  content: "\\e954";
}
.icon-table-view:before {
  content: "\\e918";
}
.icon-thumbnail-view:before {
  content: "\\e930";
}
.icon-parking-beta:before {
  content: "\\e953";
}
.icon-ortho-view:before {
  content: "\\e951";
}
.icon-perspective-view:before {
  content: "\\e952";
}
.icon-sort-asc:before {
  content: "\\e94f";
}
.icon-sort-desc:before {
  content: "\\e950";
}
.icon-download-2d:before {
  content: "\\e94d";
}
.icon-download-3d:before {
  content: "\\e94e";
}
.icon-door:before {
  content: "\\e94c";
}
.icon-campaigns:before {
  content: "\\e948";
}
.icon-land:before {
  content: "\\e949";
}
.icon-pages:before {
  content: "\\e94a";
}
.icon-projects:before {
  content: "\\e94b";
}
.icon-full-view:before {
  content: "\\e945";
}
.icon-half-view:before {
  content: "\\e946";
}
.icon-quarter-view:before {
  content: "\\e947";
}
.icon-settings:before {
  content: "\\e91f";
}
.icon-legend:before {
  content: "\\e944";
}
.icon-parking:before {
  content: "\\e943";
}
.icon-contact-view:before {
  content: "\\e941";
}
.icon-map-view:before {
  content: "\\e942";
}
.icon-copy:before {
  content: "\\e93f";
}
.icon-paste:before {
  content: "\\e940";
}
.icon-phone-filled:before {
  content: "\\e93e";
}
.icon-error:before {
  content: "\\e93a";
}
.icon-info:before {
  content: "\\e93b";
}
.icon-success:before {
  content: "\\e93c";
}
.icon-warning:before {
  content: "\\e93d";
}
.icon-phone:before {
  content: "\\e938";
}
.icon-more:before {
  content: "\\e939";
}
.icon-arrow-left:before {
  content: "\\e936";
}
.icon-sort:before {
  content: "\\e937";
}
.icon-convert-bldg:before {
  content: "\\e935";
}
.icon-twitter:before {
  content: "\\e934";
}
.icon-facebook:before {
  content: "\\e92d";
}
.icon-roof:before {
  content: "\\e933";
}
.icon-card-view:before {
  content: "\\e914";
}
.icon-export:before {
  content: "\\e932";
}
.icon-filter:before {
  content: "\\e931";
}
.icon-limit:before {
  content: "\\e904";
}
.icon-select-land:before {
  content: "\\e92f";
}
.icon-cut:before {
  content: "\\e90c";
}
.icon-destroy-building:before {
  content: "\\e92e";
}
.icon-reset:before {
  content: "\\e92c";
}
.icon-normal-screen:before {
  content: "\\e927";
}
.icon-circum-circle:before {
  content: "\\e924";
}
.icon-perim-point-delete:before {
  content: "\\e925";
}
.icon-perim-polygon:before {
  content: "\\e926";
}
.icon-sun:before {
  content: "\\e910";
}
.icon-create-building:before {
  content: "\\e901";
}
.icon-street-view:before {
  content: "\\e90e";
}
.icon-edit:before {
  content: "\\e90b";
}
.icon-mode-pieton:before {
  content: "\\e906";
}
.icon-add-point:before {
  content: "\\e900";
}
.icon-add:before {
  content: "\\e902";
}
.icon-arrow-down:before {
  content: "\\e903";
}
.icon-cancel:before {
  content: "\\e905";
}
.icon-current-loc:before {
  content: "\\e907";
}
.icon-cut-parcel:before {
  content: "\\e908";
}
.icon-delete-parcel:before {
  content: "\\e909";
}
.icon-delete-point:before {
  content: "\\e90a";
}
.icon-download:before {
  content: "\\e90d";
}
.icon-full-screen:before {
  content: "\\e90f";
}
.icon-join-parcel:before {
  content: "\\e911";
}
.icon-list-view:before {
  content: "\\e912";
}
.icon-minus:before {
  content: "\\e913";
}
.icon-mode-plan-map:before {
  content: "\\e915";
}
.icon-mode-plan:before {
  content: "\\e916";
}
.icon-move-parcel:before {
  content: "\\e917";
}
.icon-ok:before {
  content: "\\e919";
}
.icon-private:before {
  content: "\\e91a";
}
.icon-remove-collab:before {
  content: "\\e91b";
}
.icon-rotate-parcel:before {
  content: "\\e91c";
}
.icon-ruler:before {
  content: "\\e91d";
}
.icon-select-parcel:before {
  content: "\\e91e";
}
.icon-share-collab:before {
  content: "\\e920";
}
.icon-share-link:before {
  content: "\\e921";
}
.icon-start-sim:before {
  content: "\\e922";
}
.icon-stop-sim:before {
  content: "\\e923";
}
.icon-trash:before {
  content: "\\e928";
}
.icon-undo:before {
  content: "\\e929";
}
.icon-upload:before {
  content: "\\e92a";
}
.icon-window:before {
  content: "\\e92b";
}
`, "",{"version":3,"sources":["webpack://./assets/fonts/buildrzicons/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;;yDAGuD;EACvD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot?61rdwy');\n  src:  url('fonts/icomoon.eot?61rdwy#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?61rdwy') format('truetype'),\n    url('fonts/icomoon.woff?61rdwy') format('woff'),\n    url('fonts/icomoon.svg?61rdwy#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-plu-icon:before {\n  content: \"\\e95a\";\n}\n.icon-magic-wand:before {\n  content: \"\\e959\";\n}\n.icon-squence-architecturale-zoomed:before {\n  content: \"\\e958\";\n}\n.icon-attique_correction:before {\n  content: \"\\e957\";\n}\n.icon-parking-circulation:before {\n  content: \"\\e956\";\n}\n.icon-parking-icon:before {\n  content: \"\\e95d\";\n}\n.icon-arrow-up:before {\n  content: \"\\e955\";\n}\n.icon-star:before {\n  content: \"\\e954\";\n}\n.icon-table-view:before {\n  content: \"\\e918\";\n}\n.icon-thumbnail-view:before {\n  content: \"\\e930\";\n}\n.icon-parking-beta:before {\n  content: \"\\e953\";\n}\n.icon-ortho-view:before {\n  content: \"\\e951\";\n}\n.icon-perspective-view:before {\n  content: \"\\e952\";\n}\n.icon-sort-asc:before {\n  content: \"\\e94f\";\n}\n.icon-sort-desc:before {\n  content: \"\\e950\";\n}\n.icon-download-2d:before {\n  content: \"\\e94d\";\n}\n.icon-download-3d:before {\n  content: \"\\e94e\";\n}\n.icon-door:before {\n  content: \"\\e94c\";\n}\n.icon-campaigns:before {\n  content: \"\\e948\";\n}\n.icon-land:before {\n  content: \"\\e949\";\n}\n.icon-pages:before {\n  content: \"\\e94a\";\n}\n.icon-projects:before {\n  content: \"\\e94b\";\n}\n.icon-full-view:before {\n  content: \"\\e945\";\n}\n.icon-half-view:before {\n  content: \"\\e946\";\n}\n.icon-quarter-view:before {\n  content: \"\\e947\";\n}\n.icon-settings:before {\n  content: \"\\e91f\";\n}\n.icon-legend:before {\n  content: \"\\e944\";\n}\n.icon-parking:before {\n  content: \"\\e943\";\n}\n.icon-contact-view:before {\n  content: \"\\e941\";\n}\n.icon-map-view:before {\n  content: \"\\e942\";\n}\n.icon-copy:before {\n  content: \"\\e93f\";\n}\n.icon-paste:before {\n  content: \"\\e940\";\n}\n.icon-phone-filled:before {\n  content: \"\\e93e\";\n}\n.icon-error:before {\n  content: \"\\e93a\";\n}\n.icon-info:before {\n  content: \"\\e93b\";\n}\n.icon-success:before {\n  content: \"\\e93c\";\n}\n.icon-warning:before {\n  content: \"\\e93d\";\n}\n.icon-phone:before {\n  content: \"\\e938\";\n}\n.icon-more:before {\n  content: \"\\e939\";\n}\n.icon-arrow-left:before {\n  content: \"\\e936\";\n}\n.icon-sort:before {\n  content: \"\\e937\";\n}\n.icon-convert-bldg:before {\n  content: \"\\e935\";\n}\n.icon-twitter:before {\n  content: \"\\e934\";\n}\n.icon-facebook:before {\n  content: \"\\e92d\";\n}\n.icon-roof:before {\n  content: \"\\e933\";\n}\n.icon-card-view:before {\n  content: \"\\e914\";\n}\n.icon-export:before {\n  content: \"\\e932\";\n}\n.icon-filter:before {\n  content: \"\\e931\";\n}\n.icon-limit:before {\n  content: \"\\e904\";\n}\n.icon-select-land:before {\n  content: \"\\e92f\";\n}\n.icon-cut:before {\n  content: \"\\e90c\";\n}\n.icon-destroy-building:before {\n  content: \"\\e92e\";\n}\n.icon-reset:before {\n  content: \"\\e92c\";\n}\n.icon-normal-screen:before {\n  content: \"\\e927\";\n}\n.icon-circum-circle:before {\n  content: \"\\e924\";\n}\n.icon-perim-point-delete:before {\n  content: \"\\e925\";\n}\n.icon-perim-polygon:before {\n  content: \"\\e926\";\n}\n.icon-sun:before {\n  content: \"\\e910\";\n}\n.icon-create-building:before {\n  content: \"\\e901\";\n}\n.icon-street-view:before {\n  content: \"\\e90e\";\n}\n.icon-edit:before {\n  content: \"\\e90b\";\n}\n.icon-mode-pieton:before {\n  content: \"\\e906\";\n}\n.icon-add-point:before {\n  content: \"\\e900\";\n}\n.icon-add:before {\n  content: \"\\e902\";\n}\n.icon-arrow-down:before {\n  content: \"\\e903\";\n}\n.icon-cancel:before {\n  content: \"\\e905\";\n}\n.icon-current-loc:before {\n  content: \"\\e907\";\n}\n.icon-cut-parcel:before {\n  content: \"\\e908\";\n}\n.icon-delete-parcel:before {\n  content: \"\\e909\";\n}\n.icon-delete-point:before {\n  content: \"\\e90a\";\n}\n.icon-download:before {\n  content: \"\\e90d\";\n}\n.icon-full-screen:before {\n  content: \"\\e90f\";\n}\n.icon-join-parcel:before {\n  content: \"\\e911\";\n}\n.icon-list-view:before {\n  content: \"\\e912\";\n}\n.icon-minus:before {\n  content: \"\\e913\";\n}\n.icon-mode-plan-map:before {\n  content: \"\\e915\";\n}\n.icon-mode-plan:before {\n  content: \"\\e916\";\n}\n.icon-move-parcel:before {\n  content: \"\\e917\";\n}\n.icon-ok:before {\n  content: \"\\e919\";\n}\n.icon-private:before {\n  content: \"\\e91a\";\n}\n.icon-remove-collab:before {\n  content: \"\\e91b\";\n}\n.icon-rotate-parcel:before {\n  content: \"\\e91c\";\n}\n.icon-ruler:before {\n  content: \"\\e91d\";\n}\n.icon-select-parcel:before {\n  content: \"\\e91e\";\n}\n.icon-share-collab:before {\n  content: \"\\e920\";\n}\n.icon-share-link:before {\n  content: \"\\e921\";\n}\n.icon-start-sim:before {\n  content: \"\\e922\";\n}\n.icon-stop-sim:before {\n  content: \"\\e923\";\n}\n.icon-trash:before {\n  content: \"\\e928\";\n}\n.icon-undo:before {\n  content: \"\\e929\";\n}\n.icon-upload:before {\n  content: \"\\e92a\";\n}\n.icon-window:before {\n  content: \"\\e92b\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
